// extracted by css-extract-rspack-plugin
export default {"usefulQuestions":"UsefulQuestions-module__usefulQuestions___R3BGG index__mt1___Trxz5"};